import { GET } from "../../../helpers/restFunction";

export const GetnewProject = async (userId: string) => {
  const path = `/cad/users/${userId}/jobs?job_status=pending`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("Error on fetch", err);
      return err;
    });
};
